<template>
  <div class="member-list">
    <!--头部-->
    <!--<van-nav-bar title="一级用户管理" left-arrow @click-left="onClickLeft" border />-->
    <div class="list-con">
      <van-cell v-if="memberList.length>0" v-for="(item, i) in memberList" :key="i" @click="goMemberDetail(item)">
        <div class="list" slot="title">
          <div class="img-con">
            <img class="img" :src="item.avatar ? (item.avatar + '?imageView2/0/w/100/h/100') : checkQiNiuUrl('FtKRQqCkGtCCFLF_VQStosKgqOJP')" alt="">
            <span class="vip-icon" :class="'vip'+item.platformMemberLevel"></span>
          </div>
          <div class="text-con">
            <p class="name">{{ item.nickname || '' }}</p>
            <p class="date">{{ item.gmtCreate }}</p>
          </div>
        </div>
      </van-cell>

      <div class="not-data" v-if="memberList.length===0">暂无数据</div>

      <!--

      <div class="list" v-if="memberList.length>0" v-for="(item, i) in memberList" :key="i">
        <div class="img-con">
          <img src="../../../../assets/my/header-img.png" alt="">
          <img :src="item.avatar" alt="">
        </div>
        <div class="text-con">
          <p class="name">{{ item.nickname || '' }}</p>
          <p class="date">{{ item.gmtCreate | dataFormat('yyyy-MM-dd hh:mm:ss') }}</p>
        </div>
      </div>

      -->


    </div>
  </div>
</template>

<script>

import { getPlatformChildMemberLevelStatOfL1 } from '@/api/member'
export default {
  components: {
  },
  data () {
    return {
      memberList: [/*{
        "id": 0,
        "yxAccount": "0",
        "username": "0",
        "nickname": "0",
        "avatar": "http://qiniufile.xdaocloud.com/9b93fa8c9a9cef73588e15f83d3333f2.jpg",
        "inviteCode": "0",
        "gmtCreate": 0,
        "rankId": 1
      }*/]
    }
  },
  created(){
    this.getOneMemberList()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getOneMemberList() {
      getPlatformChildMemberLevelStatOfL1({}).then(res=>{
        this.memberList = res.data || [];
      })
    },
    goMemberDetail(data){
      // window.localStorage.setItem('oneMember',JSON.stringify(data));
      // this.$router.push({name: 'platformOneUser'})
    }
  }
}
</script>

<style scoped lang="less">
@url: 'https://fileqn.anttalk.vip/';
.member-list{
  .list-con{
    position: fixed;
    overflow: auto;
    height: 100%;
    width: 100%;
    padding-bottom: 60px;
    .van-cell{
      .list{
        display: flex;
        .img-con{
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 50px;
          height: 50px;
          position: relative;
          img{
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .vip-icon{
            position: absolute;
            width: 13px;
            height: 19px;
            bottom: 0px;
            right: 3px;
          }
          .vip1{
            background: url("@{url}FqvdyKzdOvhFc6yeHGCISPDh3Mq6") no-repeat 50% 50%;
            background-size: 99%;
          }
          .vip2{
            background: url("@{url}FmQsU_Ysx0rOaBp38p192_OKtyAY") no-repeat 50% 50%;
            background-size: 99%;
          }
          .vip3{
            background: url("@{url}Fn5_XQKTUnolmg_YGwNoqvaFFy6J") no-repeat 50% 50%;
            background-size: 99%;
          }

        }
        .text-con{
          flex: 1;
          display: inline-flex;
          flex-direction: column;
          overflow: hidden;
          padding-left: 15px;
          .name{
            color: rgb(43,43,43);
            font-size: 14px;
          }
          .date{
            color: rgb(136,136,136);
            font-size: 12px;
          }
        }
      }
      .van-cell__right-icon{
        line-height: 50px;
      }

    }
  }
  .not-data{
    font-size: 12px;color: #a0a0a0;padding: 24px;text-align: center;
  }
}
</style>
